import { Pipe, PipeTransform } from '@angular/core';
import { PublicTimelineItem } from 'globals/store/public.model';
import { OnsiteSession, OnsiteActivity, OnsiteAccess, OnsiteClear } from '../../../../globals/store/onsite.data';
import { FacilitatorTimelineSession } from 'globals/share/share.facilitator.functions';



@Pipe({
    name: 'timelineStart',
    standalone: true
})
export class TimelineStartPipe implements PipeTransform {
  transform({ priorSession, session }: { 
    priorSession: OnsiteSession | PublicTimelineItem | OnsiteActivity | FacilitatorTimelineSession  | OnsiteAccess | OnsiteClear, 
    session: OnsiteSession | PublicTimelineItem | OnsiteActivity | FacilitatorTimelineSession  | OnsiteAccess | OnsiteClear }): string {
    const isActivity = session['type'] === 'activity' || session['type'] === 'access' || session['type'] === 'clear'
    const hasTimezonesThatDiffer = session.hasOwnProperty('timezoneAbbr') && priorSession && priorSession.hasOwnProperty('timezoneAbbr') && priorSession['timezoneAbbr'] === session['timezoneAbbr'];
    return !isActivity && priorSession && priorSession.start === session.start && priorSession.end === session.end && hasTimezonesThatDiffer ? null : (isActivity ? session['time'] : session.start)
  }
}